import Banner from '@/components/banner'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/specialist-support')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Banner
        backgroundUrl="/img/legal.jpg"
        containerStyle="min-h-[350px] lg:min-h-[550px]"
      />
      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-5xl xl:text-6xl text-white font-bold mb-15 px-4 md:px-0">
          Domestic and Family Violence Support
        </h1>
        <div className="card sm:p-8 xl:p-10">
          <p className="text-lg font-bold mb-4">
            If you’re in immediate danger, call 000. If safe to do so, visit
            this site from a computer, tablet or smartphone that isn't being
            monitored.
          </p>
          <h3 className="text-xl font-bold">Supporting you</h3>
          <p className="text-base">
            LPE Broadband recognises the serious and often hidden impacts of
            domestic and family violence and the critical role that access to
            safe and secure telecommunications plays in supporting
            victim-survivors. We prioritise the safety of affected persons and
            are committed to:
          </p>
          <ul className="mt-3 mb-4 ml-10 list-disc list-outside">
            <li>Ensuring privacy and account security</li>
            <li>
              Where there is a safety risk, providing appropriate support and
              services, including urgently reconnecting services or providing
              alternative service options
            </li>
            <li>
              Ensuring that you do not need to disclose your experiences to
              multiple staff members
            </li>
          </ul>
          <p className="text-base mb-2">
            As an account holder, our team can help with:
          </p>
          <ul className="mt-3 mb-4 ml-10 list-disc list-outside">
            <li>
              Reviewing and updating contact information and who has authority
              on your account
            </li>
            <li>Removing services you no longer need</li>
            <li>Relocating your service</li>
            <li>Setting up a new account for a fresh start</li>
            <li>Offering flexible payment assistance options</li>
            <li>
              Providing personal phone records, bills and other account related
              data.
            </li>
          </ul>
          <p className="text-base mb-2">
            Where you are not the account holder we can establish a new account
            for you.
          </p>
          <p className="text-base mb-2">
            You can contact us in a communication method tailored to your safety
            and preferences or request a call back in the method you choose.
            Alternatively, you can nominate someone else to speak on your behalf
            including a social worker, friend and family member.
          </p>
          <p className="text-base mb-4">
            LPE Broadband is committed to providing additional Domestic and
            Family Violence support by 1 January 2026.
          </p>

          <h3 className="text-xl font-bold">Our contacts</h3>
          <p className="text-base mb-4 ml-4">
            Phone: {SUPPORTPHONE}
            <br />
            8:30am – 5:00pm AEST Monday - Friday
          </p>

          <h3 className="text-xl font-bold">
            What if I am having trouble paying for my services?
          </h3>
          <p className="text-base mb-2">
            LPE Broadband will provide free financial hardship assistance
            without requiring evidence where you are experiencing or overcoming
            domestic or family violence, unless legally required. We can offer a
            range of options to help you stay connected when you are
            experiencing financial hardship.
          </p>
          <p className="text-base mb-4">
            For more information on financial hardship assistance please see our{' '}
            <a href="/pdf/payment-assistance-policy.pdf" target="_blank">
              Payment Assistance Policy
            </a>{' '}
            or email us at{' '}
            <a href={`mailto:${SUPPORTEMAIL}`} target="_blank">
              {SUPPORTEMAIL}
            </a>{' '}
            or call us on {SUPPORTPHONE}.
          </p>

          <h3 className="text-xl font-bold">External support services</h3>
          <ul className="mt-3 mb-4 ml-10 list-disc list-outside">
            <li>
              <a target="_blank" href="https://www.1800respect.org.au/">
                1800RESPECT (National Domestic Violence and Sexual Assault
                Helpline)
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1800737732">1800 737 732 </a>
              <br />
              1800RESPECT is available for free, 24 hours a day, 7 days a week
              to support people impacted by domestic, family or sexual violence.
            </li>
            <li>
              <a target="_blank" href="https://www.lifeline.org.au/">
                Lifeline
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:131114">13 11 14</a> <br />
              Provides crisis support and suicide prevention services.
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.health.gov.au/contacts/elder-abuse-phone-line"
              >
                1800 ELDERHelp
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1800353374">1800 353 374</a>
              <br />A free call service that automatically redirects callers
              seeking information and advice on elder abuse with the existing
              phone line service in their jurisdiction.
            </li>
            <li>
              <a target="_blank" href="https://fullstop.org.au/">
                Full Stop
              </a>
              <br />
              <strong>Phone: </strong>
              <a href="tel:https://fullstop.org.au/">1800 385 578</a>
              <br />
              Offers free, 24/7, confidential, trauma specialist counselling to
              people of all genders who have been subject to sexual, domestic
              and family violence, as well as their friends, colleagues and
              family members.
            </li>
            <li>
              <a target="_blank" href="https://ndh.org.au/">
                National Debt Helpline
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1800007007">1800 007 007</a>
              <br />
              The National Debt Helpline is a not-for-profit service that helps
              people with debt problems.
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.jobaccess.gov.au/complaints-or-report-abuse/make-complaint-report-abuse#national-disability-abuse-and-neglect-hotline"
              >
                National Disability Abuse and Neglect Hotline
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1800880052">1800 880 052</a>
              <br />
              The National Disability Abuse and Neglect Hotline is for reporting
              abuse or neglect of people with disability.
            </li>
            <li>
              <a
                target="_blank"
                href="https://fullstop.org.au/get-help/our-services/rainbowviolenceandabusesupport"
              >
                Rainbow Sexual, Domestic and Family Violence Helpline
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1800497212">1800 497 212</a>
              <br />
              Provides support for those from LGBTQ+ communities, family,
              friends and supporters who have recently or in the past
              experienced sexual, domestic or family violence.
            </li>
            <li>
              <a target="_blank" href="https://clcs.org.au/legal-help">
                Community Legal Centres Australia
              </a>
              <br />
              Provides a comprehensive list of community legal centres across
              Australia. These centres often offer free or low-cost legal advice
              and can be a helpful resource for those experiencing domestic
              violence or other legal issues.
            </li>
            <li>
              <a target="_blank" href="https://ntv.org.au/mrs/">
                Men’s Referral Service
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1300766491">1300 766 491 </a>
              <br />
              Provides a range of services to support men concerned about their
              behaviour to change what they are doing and keep women, children
              and communities safer.
            </li>
            <li>
              <a target="_blank" href="https://www.familyrelationships.gov.au/">
                Family Relationships Online
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1800050321">1800 050 321</a>{' '}
              <br />A national telephone service providing help for families
              affected by relationship or separation issues, including
              information on parenting arrangements after separation.
            </li>
            <li>
              <a target="_blank" href="https://relationships.org.au/">
                Relationships Australia
              </a>
              <br />
              <strong>Phone:</strong> <a href="tel:1300364277">1300 364 277 </a>
              <br />
              Provides relationship support services for individuals, families,
              and communities, including counselling, family dispute resolution,
              and family/community support and education programs.
            </li>
            <li>
              <a target="_blank" href="https://nationallegalaid.org.au/">
                National Legal Aid
              </a>
              <br />
              National Legal Aid is a network that links to the legal aid
              commissions in each state and territory in Australia. They can
              provide you with the necessary legal assistance and resources in
              your area.
            </li>
            <li>
              <a target="_blank" href="https://www.accesshub.gov.au/">
                National Relay Service
              </a>{' '}
              <br />
              The NRS provides a range of different types of call services,
              depending on your needs and preferences.
            </li>
            <li>
              <a target="_blank" href="https://www.accesshub.gov.au/">
                Translation and interpreting services
              </a>
              <br />
              The Translating and Interpreting Service (TIS National) is a
              language service provided by the Department of Home Affairs for
              people with limited English proficiency and for agencies and
              businesses that need to communicate with their non-English
              speaking clients.
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
